<template>
  <b-row class="company-profile-section">
    <b-col class="pl-3 pr-3 mt-1">
      <div class="profile-picture-container">
        <b-row>
          <b-img
            :src="companyInfo.logo"
            fluid
            alt="Fluid image"
            class="profile-picture"
          ></b-img>
        </b-row>
        <b-row class="company-wall-type mt-2 mb-2">
          <p class="company-wall-type-p">{{ companyInfo.company_type }}</p>
        </b-row>
        <b-row class="company-wall-contacts text-center mt-2 mb-2">
          <CompanyNetwork :company-id="$route.params.companyId" />
        </b-row>
        <b-row
          class="no-gutters mt-3"
          v-if="companyInfo.url !== userInfo.company"
        >
          <b-button
            class="profile-follow-btn"
            block
            v-on:click="companyFollow"
            v-if="companyFollowStatus !== true"
            ><i class="far fa-eye profile-follow-icon"></i> Follow</b-button
          >
          <b-button
            class="profile-follow-btn"
            block
            variant="info"
            @click="companyUnFollow"
            v-if="companyFollowStatus === true"
            ><i class="far fa-eye-slash profile-follow-icon"></i>
            UnFollow</b-button
          >
        </b-row>
      </div>
    </b-col>
    <b-col class="mt-2 mb-2 mobile-company-profile-section">
      <p class="company-title">MY COMPANY</p>
      <b-row class="mobile-profile-container m-0">
        <b-col class="img-col p-0">
          <img :src="companyInfo.logo" class="mobile-profile-img" />
        </b-col>
        <b-col class="mobile-profile-name-contact">
          <p class="profile-booked-events-name">
            {{ companyInfo.name }}
          </p>
          <p class="profile-booked-events-date">
            {{ companyInfo.address }}
          </p>
        </b-col>
        <b-col class="mobile-profile-name-contact">
          <CompanyNetwork
            :company-id="$route.params.companyId"
            class="company-network"
          />
          <div class="profile-wall-btn-div" v-if="companyInfo && companiesPost.length">
            <router-link
              :to="{
                name: 'CompanyWall',
                params: { companyId: this.$route.params.companyId },
              }"
            >
              <b-button class="profile-wall-btn" block
                ><i class="fas fa-list profile-wall-icon"></i>
                {{ `${companyInfo.name}’s Wall` }}</b-button
              >
            </router-link>
          </div>
        </b-col>
      </b-row>
      <b-row class="mobile-profile-member-since">
        <p class="m-0">
          Member since {{ moment(companyInfo.created).format("DD.MM.YYYY") }}
        </p>
      </b-row>
      <b-row class="no-gutters" v-if="companyInfo.url !== userInfo.company">
        <b-button
          class="profile-follow-btn"
          block
          v-on:click="companyFollow"
          v-if="companyFollowStatus !== true"
          ><i class="far fa-eye profile-follow-icon"></i> Follow</b-button
        >
        <b-button
          class="profile-follow-btn"
          block
          variant="info"
          @click="companyUnFollow"
          v-if="companyFollowStatus === true"
          ><i class="far fa-eye-slash profile-follow-icon"></i>
          UnFollow</b-button
        >
      </b-row>
    </b-col>
    <b-col class="pl-3 pr-3 mt-1">
      <b-row class="mb-3 profile-information-container">
        <b-col class="p-3">
          <p class="profile-owner-name">
            {{ companyInfo.name }}
          </p>
          <p class="profile-owner-title mb-2">{{ companyInfo.address }}</p>
          <p class="profile-member-since">
            Member since
            {{ moment(companyInfo.created).format("DD.MM.YYYY") }}
          </p>
        </b-col>
        <b-col cols="3" class="">
          <div class="profile-wall-btn-div" v-if="companyInfo && companiesPost.length">
            <router-link
              :to="{
                name: 'CompanyWall',
                params: { companyId: this.$route.params.companyId },
              }"
            >
              <b-button class="profile-wall-btn" block
                ><i class="fas fa-list profile-wall-icon"></i>
                {{ `${companyInfo.name}’s Wall` }}</b-button
              >
            </router-link>
          </div>
        </b-col>
      </b-row>

      <b-row class="company-info-section">
        <div class="col-lg-6 col-12 mt-2 align-self-start mb-1">
          <b-card no-body>
            <b-card-header header-tag="header" :class="`${isDescriptionExpanded ? '' : 'collapsed'}`" role="tab">
              <b-button  @click="isDescriptionExpanded = !isDescriptionExpanded" block v-b-toggle.description-accordion variant="light" class="header-btn"
                ><p class="profile-biography-title">DESCRIPTION</p> <i :class="`fas fa-angle-${isDescriptionExpanded ? 'up': 'down'}`"></i
              ></b-button>
            </b-card-header>
            <b-collapse
              id="description-accordion"
              accordion="description-acc"
              role="tabpanel"
            >
              <b-card-body>
                <p class="profile-biography">{{ companyInfo.description }}</p>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div class="col-lg-6 col-12 col-web-contacts">
          <b-card no-body v-if="
                companyInfo.display_configuration.show_email ||
                companyInfo.display_configuration.show_phone_number
              " class="mt-2 mb-1">
          <b-card-header header-tag="header" :class="`${isContactExpanded ? '' : 'collapsed'}`" role="tab">
            <b-button  @click="isContactExpanded = !isContactExpanded" block v-b-toggle.contact-accordion variant="light" class="header-btn"
              ><p class="profile-biography-title">CONTACTS</p> <i :class="`fas fa-angle-${isContactExpanded ? 'up': 'down'}`"></i
            ></b-button>
          </b-card-header>
          <b-collapse
            id="contact-accordion"
            accordion="biography-acc"
            role="tabpanel"
          >
            <b-card-body>
              <b-col
                cols="12"
                v-if="companyInfo.display_configuration.show_email"
                class="profile-contacts-text p-0 text-center"
              >
                <i class="fas fa-envelope-square profile-contacts-icons"> </i>
                {{ companyInfo.contact_email }}
              </b-col>
              <b-col
                cols="12"
                v-if="companyInfo.display_configuration.show_phone_number"
                class="profile-contacts-text p-0 text-center"
              >
                <i class="fas fa-phone-square profile-contacts-icons"> </i>
                {{ companyInfo.mobile_number }}
              </b-col>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mt-2 mb-1">
          <b-card-header header-tag="header" :class="`${isAreaOfInterestExpanded ? '' : 'collapsed'}`" role="tab">
            <b-button  @click="isAreaOfInterestExpanded = !isAreaOfInterestExpanded" block v-b-toggle.areas-accordion variant="light" class="header-btn"
              ><p class="profile-biography-title">AREAS OF INTEREST</p> <i :class="`fas fa-angle-${isAreaOfInterestExpanded ? 'up': 'down'}`"></i
            ></b-button>
          </b-card-header>
          <b-collapse
            id="areas-accordion"
            accordion="areas-acc"
            role="tabpanel"
          >
            <b-card-body>
              <div class="profile-segments-div">
                <b-badge
                  v-for="(item, index) in companyInfo.areas_of_interest"
                  :key="index"
                  class="company-profile-segment"
                  variant="dark"
                >
                  {{ item }}
                </b-badge>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mt-2 mb-1">
          <b-card-header header-tag="header" :class="`${isRegionsOfInterestExpanded ? '' : 'collapsed'}`" role="tab">
            <b-button  @click="isRegionsOfInterestExpanded = !isRegionsOfInterestExpanded" block v-b-toggle.regions-accordion variant="light" class="header-btn"
              ><p class="profile-biography-title">REGIONS OF INTEREST</p> <i :class="`fas fa-angle-${isRegionsOfInterestExpanded ? 'up': 'down'}`"></i
            ></b-button>
          </b-card-header>
          <b-collapse
            id="regions-accordion"
            accordion="regions-acc"
            role="tabpanel"
          >
            <b-card-body>
              <div class="profile-segments-div">
                <b-badge
                  v-for="(item, index) in companyInfo.regions_of_interest"
                  :key="index"
                  class="company-profile-segment"
                >
                  {{ item }}
                </b-badge>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mt-2 mb-1">
          <b-card-header header-tag="header" :class="`${isEmployeeExpanded ? '' : 'collapsed'}`" role="tab">
            <b-button  @click="isEmployeeExpanded = !isEmployeeExpanded" block v-b-toggle.employees-accordion variant="light" class="header-btn"
              ><p class="profile-biography-title">EMPLOYEES</p> <i :class="`fas fa-angle-${isEmployeeExpanded ? 'up': 'down'}`"></i
            ></b-button>
          </b-card-header>
          <b-collapse
            id="employees-accordion"
            accordion="employees-acc"
            role="tabpanel"
          >
            <b-card-body class="py-0">
              <b-row
              v-for="(member, index) in companyInfo.members"
              :key="index"
              class="profile-booked-events-container"
            >
              <b-col lg="2" cols="2" class="mobile-user-info">
                <img :src="member.prof_pic" class="profile-booked-events-img" />

                </b-col>
                <b-col lg="7" cols="6" class="user-info-detail">
                  <div class="p-1">
                  <p class="profile-booked-events-name" @click="goToProfile(member.customer_id)">
                    {{ member.name }}
                  </p>
                  <p class="profile-booked-events-date">
                    {{ member.job_title }}
                  </p>
                </div>
                </b-col>
                <b-col lg="3" cols="4"
                  class="iconsForUserDesc"
                  v-show="member.customer_id !== userInfo.customer_id"
                >
                  <i
                    class="fas fa-user-friends action-icon"
                    v-b-tooltip.hover
                    title="Request has been sent"
                    v-if="member.friendship_request.status === 'sent request'"
                    style="cursor: default"
                  />
                  <i
                    class="fas fa-user-friends action-icon"
                    v-b-tooltip.hover
                    title="Member sent Request to you"
                    v-if="
                      member.friendship_request.status ===
                      'pending request or you'
                    "
                    @click="goToNetwork()"
                  />
                  <i
                    class="fas fa-user-plus action-icon"
                    v-b-tooltip.hover
                    title="Add member"
                    v-if="
                      member.friendship_request.status === '' &&
                      !isMemberMarkedMeAsSpam(member) &&
                      !isMarkedAsSpam(member.customer_id)
                    "
                    @click="
                      toNetwork(member),
                        (member.friendship_request.status = 'friend'),
                        (member.friendship_request.status = 'sent request')
                    "
                  />
                  <i
                    class="fas fa-user-times action-icon"
                    style="color: gray"
                    v-b-tooltip.hover
                    title="Unfriend Member"
                    v-if="member.friendship_request.status === 'friend'"
                    @click="
                      deleteNetwork(member.friendship_request.network_url),
                        (member.friendship_request.status = '')
                    "
                  />
                  <i
                    class="fas fa-eye action-icon"
                    v-b-tooltip.hover
                    title="Follow"
                    v-if="!!member.follow_status.following === false"
                    @click="
                      followReq(member), (member.follow_status.following = true)
                    "
                  />
                  <i
                    class="fas fa-eye-slash action-icon"
                    v-b-tooltip.hover
                    title="Unfollow"
                    v-else
                    @click="
                      UnFollowReq(member),
                        (member.follow_status.following = false)
                    "
                  />
                  <i
                    v-if="isMarkedAsSpam(member.customer_id)"
                    class="fas fa-info-circle action-icon"
                    v-b-tooltip.hover
                    title="Unblock"
                    @click="removeFromSpamList(member)"
                  />
                  <i
                    v-else-if="!isMemberMarkedMeAsSpam(member)"
                    class="fas fa-envelope action-icon"
                    v-b-tooltip.hover
                    title="Message"
                    @click="sendMsg(member)"
                  />
              </b-col>
            </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>

        </div>
      </b-row> 
    </b-col>
  </b-row>
</template>

<script scoped>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import CompanyNetwork from '../../components/CompanyNetwork.vue';

export default {
  name: 'CompanyProfilePage',
  components: {
    CompanyNetwork,
  },
  data() {
    return {
      companyInfo: { display_configuration: {} },
      companyUrl: '',
      companyFollowStatus: false,
      congratulationModalShow: false,
      networkModalText: '',
      companiesPost: [],
      isDescriptionExpanded: false,
      isContactExpanded: false,
      isAreaOfInterestExpanded: false,
      isRegionsOfInterestExpanded: false,
      isEmployeeExpanded: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
      isMobileScreen: 'isMobileScreen',
    }),
  },
  async created() {
    const { companyId } = this.$route.params;
    try {
      this.companyInfo = await this.fetchCompanyPublicInfo(companyId);
      this.companyUrl = this.companyInfo.url;
      this.companyFollowStatus = this.companyInfo.follow_status;
      const data = await this.companyWall({
        page: 1,
        companyId,
      });
      this.companiesPost = data.results;
    } catch (err) {
      this.$router.push({ name: 'NotFound' });
    }
    if (!this.isMobileScreen) {
      document.querySelectorAll('.header-btn').forEach((el) => {
        el.click();
      });
    }
  },
  methods: {
    ...mapActions({
      fetchCompanyPublicInfo: 'companies/fetchCompanyPublicInfo',
      followUnfollowCompany: 'companies/followUnfollowCompany',
      follow: 'network/follow',
      conversationList: 'messages/getConversationList',
      createNewConversation: 'messages/createNewConversation',
      addToNetwork: 'user/userInvitationRequest',
      unFollowMember: 'network/unFollowMember',
      addRemoveSpam: 'user/addRemoveSpam',
      deleteMember: 'user/deleteMember',
      fetchUserPublicInfo: 'user/fetchUserPublicInfo',
      companyWall: 'companies/companyWall',

    }),
    moment(date) {
      return moment(new Date(date));
    },
    async companyFollow() {
      try {
        await this.followUnfollowCompany({
          action: 'follow',
          company: this.companyUrl,
        });
        this.companyFollowStatus = !this.companyFollowStatus;
      } catch (err) {
        throw new Error(err);
      }
    },
    async companyUnFollow() {
      try {
        await this.followUnfollowCompany({
          action: 'unfollow',
          company: this.companyUrl,
        });
        this.companyFollowStatus = !this.companyFollowStatus;
      } catch (err) {
        throw new Error(err);
      }
    },
    goToProfile(id) {
      if (id) {
        const customerId = `${id}`;
        this.$router.push({ name: 'userProfilePage', params: { customerId } });
      }
    },
    goToNetwork() {
      this.$router.push({ name: 'network' });
    },
    async followReq(customer) {
      if (!customer.follow_status.following) {
        try {
          const owner = await this.fetchUserPublicInfo();
          await this.follow({ follower: owner.url, following: customer.url });
          this.congratulationModalShow = true;
          this.networkModalText = `You are now following ${customer.user.first_name} ${customer.user.last_name}.`;
          const userIndex = this.companyInfo.members.findIndex(
            u => u.id === customer.id,
          );
          this.companyInfo.members[userIndex].follow_status.following = true;
          this.$notify({
            group: 'friend',
            title: 'success',
            text: 'Member have been added to your followers list!',
            type: 'success',
          });
        } catch (e) {
          if (e.response) {
            this.networkModalText = '';
            this.congratulationModalShow = false;
            this.$notify({
              group: 'friend',
              title: 'error',
              text: `${e.response.data}`,
              type: 'error',
            });
          }
        }
      }
    },
    async UnFollowReq(customer) {
      if (customer.follow_status.following_url) {
        try {
          await this.unFollowMember(customer.follow_status.following_url);
          this.$notify({
            group: 'friend',
            title: 'success',
            text: 'Member have been deleted from your followers list!',
            type: 'success',
          });
        } catch (err) {
          this.$notify({
            group: 'friend',
            title: 'error',
            text: `${err.name}`,
            type: 'error',
          });
        }
      }
    },
    async toNetwork(customer) {
      if (!customer.friendship_request.status) {
        try {
          const owner = await this.fetchUserPublicInfo();
          if (customer.url) {
            await this.addToNetwork({
              requested_by: owner.url,
              requested_to: customer.url,
            });
            if (!!customer.follow_status.following === false) {
              await this.follow({
                follower: owner.url,
                following: customer.url,
              });
            }
            const userIndex = this.companyInfo.members.findIndex(
              u => u.id === customer.id,
            );
            this.companyInfo.members[userIndex].follow_status.following = true;
          }
          this.$notify({
            group: 'friend',
            title: 'success',
            text: 'Friend request has been sent!',
            type: 'success',
          });
          this.congratulationModalShow = true;
          this.networkModalText = `Your Network request has been successfully sent to
          ${customer.user.first_name} ${customer.user.last_name}.`;
          const userIndex = this.companyInfo.members.findIndex(
            u => u.id === customer.id,
          );
          this.companyInfo.members[userIndex].friendship_request.status = 'friend';
        } catch (e) {
          if (e) {
            this.networkModalText = '';
            this.congratulationModalShow = false;
            this.$notify({
              group: 'friend',
              title: 'error',
              text: `${e.message}`,
              type: 'error',
            });
          }
        }
      }
    },
    async deleteNetwork(url) {
      try {
        await this.deleteMember(url);
        this.$notify({
          group: 'friend',
          title: 'success',
          text: 'Friend have been deleted!',
          type: 'success',
        });
      } catch (err) {
        this.$notify({
          group: 'friend',
          title: 'error',
          text: `${err.message}`,
          type: 'error',
        });
      }
    },
    isMarkedAsSpam(id) {
      return (
        this.userInfo.spam_list
        && this.$lodash.get(this.userInfo, 'spam_list').includes(id)
      );
    },
    isMemberMarkedMeAsSpam({ spam_list = [] }) {
      return spam_list.includes(this.userInfo.customer_id);
    },

    async removeFromSpamList({ customer_id, url }) {
      await this.addRemoveSpam({
        customer_id,
        customer: url,
        action: 'remove',
      });
    },
    async sendMsg(user) {
      try {
        const { result } = await this.createNewConversation({
          receiver_id: user.user_id,
        });
        this.$router.push({
          name: 'currentMessage',
          params: {
            chatRoomId: result.chat_room_id,
            user,
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style scoped>
.iconsForUserDesc {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    column-gap: 10px;
  }
  .iconsForUserDesc > i {
    font-size: 14px;
    color: #bd9d5f;
    cursor: pointer;
  }
.action-icon{
    background-color: #f3f3f3;
    padding: 6px;
    margin: 1px;
    border-radius: 50%;
    color: #bd9d5f;
  }

.company-profile-section {
  display: grid;
  grid-template-columns: 310px 1fr;
  margin-right: 0;
}
.profile-picture-container {
  background: white;
  max-width: 310px;
  margin: 0 auto;
}
.profile-picture-container > div {
  margin: 0;
}
.mobile-company-profile-section {
  display: none;
}
.profile-picture {
  object-fit: cover;
}
.profile-contact {
  font-size: 17px;
  color: #bd9d5f;
  font-family: Arial;
  line-height: 1.13;
  border-bottom: 1px solid #ebebeb;
  padding: 15px;
}
.profile-segments-div {
  text-align: left;
}
.profile-segments-div > span {
  border-radius: 0 8px 8px 8px;
}
.profile-segment {
  margin: 5px;
  padding: 4px;
  background-color: #dbdbdb;
  font-size: 12px;
  line-height: 1.17;
  font-family: Arial;
  text-align: left;
  color: #7f7f7f;
  border-radius: 1px;
}
.profile-message-btn {
  background-color: #bd9d5f !important;
  color: white;
  font-size: 15px;
  text-align: center;
  border: 0;
  border-right: 1px solid white;
  box-shadow: none;
}
.profile-follow-btn {
  color: white;
  font-size: 14px;
  text-align: center;
  background-color: #bd9d5f;
  border: 1px solid #bd9d5f;
  box-shadow: none;
  border-radius: 0;
}
.profile-follow-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.profile-message-icon,
.profile-follow-icon,
.profile-wall-icon {
  font-size: 13.5px;
}
.profile-information-container {
  background: white;
}
.profile-owner-name {
  font-family: Arial;
  font-size: 28px;
  line-height: 1.17;
  text-align: left;
  font-weight: bold;
  color: #333333;
  margin: 0;
  text-transform: capitalize;
}
.profile-owner-title {
  font-family: Arial;
  font-size: 18px;
  line-height: 1.17;
  font-weight: bold;
  color: #666666;
  margin: 0;
  text-transform: capitalize;
}
.profile-owner-company-name {
  font-family: Arial;
  font-size: 18px;
  line-height: 1.17;
  font-size: 18px;
  color: #bd9d5f;
  text-transform: capitalize;
}
.profile-member-since {
  font-family: Arial;
  font-size: 11px;
  line-height: 1.09;
  text-align: left;
  color: #666666;
  margin: 0;
}
.profile-biography-title,
.profile-booked-events-title {
  font-family: Montserrat;
  font-size: 18px;
  line-height: 1.22;
  text-align: center;
  color: #333333;
  margin: 0;
  word-wrap: break-word !important;
}
.profile-biography-title-container,
.profile-booked-events-title-container {
  background-color: white;
  border-bottom: solid 1px #dbdbdb;
  justify-content: center;
}
.profile-biography-text-container {
  background-color: white;
}
.profile-biography {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.15;
  text-align: left;
  color: #666666;
}
.profile-contacts-icons {
  color: #aaaaaa;
  font-size: 15px;
}
.profile-contacts-text {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.15;
  text-align: left;
  color: #bd9d5f;
}
.profile-contacts-text:not(:last-child) {
  margin-bottom: 10px;
}
.profile-booked-events-img {
  height: 60px;
  width: 60px;
  object-fit: cover;
}
.profile-booked-events-name {
  font-family: Arial;
  font-size: 16px;
  line-height: 1.23;
  text-align: left;
  font-weight: bold;
  color: #333;
  margin: 0;
  cursor: pointer;
}
.profile-booked-events-date {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.23;
  text-align: left;
  color: #707070;
  margin: 0;
}
.profile-booked-events-container {
  background-color: #fff;
  border-bottom: 1px solid #ebebeb;
  padding: 15px 4px;
}
.profile-wall-btn-div {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.profile-wall-btn {
  background-color: #bd9d5f;
  color: white;
  font-size: 15px;
  border: 0;
  border-right: 1px solid white;
  box-shadow: none;
  border-radius: 0;
}
.company-wall-type-p {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.15;
  color: #333333;
  margin: 7px 0 -3px 0;
}
.company-wall-type {
  border-top: 1px solid #ebebeb;
  justify-content: center;
}
.company-wall-contacts {
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}
.company-profile-segment {
  margin: 5px;
  padding: 4px;
  background-color: #bd9d5f;
  font-size: 12px;
  line-height: 1.17;
  font-family: Arial;
  text-align: left;
  color: #ffffff;
  border-radius: 1px;
}
.company-info-section > div:nth-of-type(1) {
  margin-left: 0;
}
.company-info-section > div:nth-of-type(2) {
  padding-left: 27px;
}
.company-title {
  display: none;
}
@media (max-width: 980px) {
  .company-info-section {
    display: grid;
    grid-template-columns: 1fr;
  }
  .company-info-section > div:nth-of-type(2) {
    padding-left: 15px;
  }
}
@media (max-width: 1024px) {
  .profile-booked-events-container:last-child { 
    border-bottom: 1px solid transparent;
}
  .company-info-section > div:nth-of-type(2) {
    padding-left: 15px !important;
    margin-left: auto !important;
  }
  .company-title {
    display: block;
    color: #666;
    margin: 0;
    padding: 10px 0;
    text-align: center;
    border-bottom: 1px solid #ebebeb;
  }
  .company-profile-section {
    display: grid;
    grid-template-columns: 1fr;
    padding-left: 15px;
    margin-top: 8px;
  }
  .company-profile-section > div:nth-of-type(1) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .company-profile-section > .col:first-child,
  .profile-information-container,
  .profile-wall-btn > i {
    display: none;
  }
  .mobile-company-profile-section {
    display: block;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 0 10px 10px 10px;
  }
  .mobile-profile-container {
    display: grid;
    grid-template-columns: 1fr 5fr 5.4fr;
  }
  .img-col {
    margin-right: 1px;
  }
  .mobile-profile-name-contact {
    background-color: #fff;
    position: relative;
    padding: 4px 0 0 8px;
  }
  .mobile-profile-name-contact > .company-network {
    position: absolute;
    top: 2px;
    right: 3px;
    width: 32px;
    margin: 0;
    padding: 0;
  }
  .mobile-profile-name-contact > .profile-wall-btn-div {
    bottom: 8px;
    right: 8px;
  }
  .mobile-profile-img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    background-color: white;
    border-right: 1px solid #ebebeb;
  }
  .mobile-profile-member-since {
    padding: 4px;
    justify-content: center;
    background-color: #fff;
    font-size: 10px;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
  }
  .profile-wall-btn {
    border-radius: 0 10px 10px 10px;
    font-size: 10px;
    padding: 4px 7px;
  }
  .profile-wall-btn,
  .profile-follow-btn {
    background-color: #f3f3f3;
    border: unset;
    color: #7f7f7f;
  }
  .profile-biography-title-container {
    border-radius: 0 10px 0 0;
  }
  .profile-biography-title {
    font-size: 13px;
  }
  .profile-booked-events-name {
    font-weight: 700;
  }
  .profile-biography-text-container {
    border-radius: 0 0 10px 10px;
  }
  .profile-booked-events-container p {
    font-size: 10px;
  }
  .profile-booked-events-container:last-child {
    border-radius: 0 0 10px 10px;
  }
  .profile-booked-events-container:last-child img {
    border-radius: 0 0 0 9px;
  }
  .have-no-employees {
    border-radius: 0 10px 10px 10px;
  }
  .company-profile-segment {
    background-color: #aaa;
  }
  .mobile-user-info {
    margin-left: -9px;
    padding-left: 0;
  }
  .user-info-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .profile-booked-events-container {
    margin-right: -19px;
  }

  .profile-booked-events-container {
      padding: 0px 4px;
      margin-bottom: 1px;
    }
}
.card  {
    margin: 0 -15px;
    border-radius: 0 10px 10px 10px;
  }
  .card-header {
    background-color: #fff;
    border-radius: 0 10px 0 0;
  }
  .card-header.collapsed {
    border-radius: 0 10px 10px 10px;
  }
  .card-header .header-btn {
    background-color: #fff;
    border: none;
    outline: none;
    box-shadow: none !important;
  }
.header-btn {
    position: relative;
  }
.header-btn i {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 23px;
}
</style>
